import $ from 'jquery';

export default function logEngagement(url, module, action, params){
    if (!url) {
        url = window.location.href;
    }
    if (params) {
        url += ((url.indexOf('?') >= 0) ? '&' : '?') +
            ((typeof params === 'string' || params instanceof String) ? params : $.param(params));
    }
    $.ajax({
        type: 'POST',
        data: $.param({
            url: url,
            module: module,
            action: action
        }),
        url: '/r/ajax/LogEngagement.jsp'
    });
}


// WEBPACK FOOTER //
// ./src/scripts/modules/log-engagement.js